<template>
	<div class="pagination">
		<div class="pagination_flex">
			<button class="pagination_flex_item" :disabled="pageindex <= 1" @click="MinusPageindex">&lt;</button>
			<button :class="{ pagination_flex_item_active: pageindex === item }" @click="addbuttonActive(item)"
				class="pagination_flex_item" v-for="item in Math.ceil(props.initPageIndex / 10)">{{item}}</button>
			<button class="pagination_flex_item" :disabled="pageindex >= Math.ceil(props.initPageIndex / 10)"
				@click="AddPageindex">&gt;</button>
		</div>
	</div>
</template>

<script setup>
	import {
		ref,
		computed,
		defineEmits,
		defineProps
	} from 'vue';

	const props = defineProps({
		initPageIndex: {
			type: Number,
			required: true,
		},
	});
	const emit = defineEmits(['changePage']);
	const pageindex = ref(1);

	function addbuttonActive(e) {
		pageindex.value = e;
		emit('changePage', pageindex.value); // 触发自定义事件，将 pageindex 传递给父组件
	}

	function MinusPageindex() {
		if (pageindex.value > 1) {
			pageindex.value--
			emit('changePage', pageindex.value); // 触发自定义事件，将 pageindex 传递给父组件
		}

	}

	function AddPageindex() {
		if (pageindex.value < Math.ceil(props.initPageIndex / 10)) {
			pageindex.value++
			emit('changePage', pageindex.value); // 触发自定义事件，将 pageindex 传递给父组件
		}
	}
</script>

<style lang="scss" scoped>
	.pagination_flex {
		width: 400px;
		height: 40px;
		margin: 0 auto;

		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		margin-top: 10px;


		.pagination_flex_item {
			margin-left: 10px;
			color: white;
			font-size: 16px;
			height: 30px;
			line-height: 30px;
			width: 30px;
			border: 1px solid #007e62;
			text-align: center;
			background-color: #114748;
		}

		button:hover {
			background-color: #007e62;
		}

		.pagination_flex_item_active {
			background-color: #007e62;
		}

		/* 禁用按钮的样式 */
		button:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		button:disabled:hover {
			background-color: #114748;
		}

	}
</style>